export default "__VITE_ASSET__DyZKXd$4__"